<template>
  <!-- refactor(compoments): TheFooter
add(compoments): TheFooter
  rm(compoments): TheFooter-->
  <footer>
    <p>© Copyright 2020-2020 - PnA Apps v1.0 - PnA Publicidade Ltda.</p>
  </footer>
</template>

<script>
export default {
  name: "TheFooter",
};
</script>

<style scoped>
footer {
  background: #252525;
  padding: 25px 0;
  text-align: center;
  font-size: 1.2rem;
  color: #fff;
  position: relative;
  top: 75px;
}
</style>
